module.exports = __webpack_public_path__ + "img/gthsjyy.8995ab8a.png";